import { BaseModel } from './base.model'
import { ParsedUser } from './parsed-user.model'

export class PhoneControl extends BaseModel<PhoneControl> {
  static DEFAULT_ATTRIBUTES = {}

  file: File
  fileUrl: string
  users: ParsedUser[]
  mark: number
  sender: string
  source: string
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/phone_control.model.ts